import { render, staticRenderFns } from "./UserInfoWidget.vue?vue&type=template&id=a3c8e812"
import script from "./UserInfoWidget.vue?vue&type=script&lang=js"
export * from "./UserInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./UserInfoWidget.vue?vue&type=style&index=0&id=a3c8e812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports